import React from 'react';
export function Footer() {
  return <footer className="bg-ink-deep py-10 text-cream/70" data-id="element-66" data-mp="32wd2qgad7ltj">
      <div className="mx-auto max-w-content space-y-3 px-5 text-center text-[13px] leading-relaxed sm:px-8" data-id="element-67" data-mp="3gfsjo3v2keir">
        <p className="font-display text-[18px] text-cream" data-id="element-68" data-mp="32onl753ftsa0">The Worry-to-Brave Toolkit</p>
        <p className="mx-auto max-w-2xl" data-id="element-69" data-mp="36oxw8w6378vq">
          The Worry-to-Brave Toolkit is an educational parenting resource and is not a substitute for individualized medical,
          psychological or mental-health care.
        </p>
        <p data-id="element-70" data-mp="37fvf8oqf24t">© {new Date().getFullYear()} The Worry-to-Brave Toolkit. All rights reserved.</p>
      </div>
    </footer>;
}